import { EnqueueSnackbar } from "notistack";
import { APIRoutes } from "../../../../constants";
import { RequestServer } from "../../../../utils/services";
import { ClientAgendasApiResponse, ClientAgendaApiData, AgendaEntry, AgendaQuestionResponse, FormattedAgenda } from "./type";
import { Dispatch, SetStateAction } from "react";


export async function getClientAgendas(setAgendaData: Dispatch<SetStateAction<ClientAgendaApiData>>, enqueueSnackbar: EnqueueSnackbar, setLoading: (b: boolean) => void, fk_project: string) {
    try {
        setLoading(true);
        const response: ClientAgendasApiResponse = await RequestServer(APIRoutes.PE_CLIENT_AGENDAS + "?fk_project=" + fk_project,"GET");

        if(response.success) {
            setAgendaData(response.data);
        } else {
            enqueueSnackbar(response.message || "Something went wrong");
        }
        
    } catch(err) {
        enqueueSnackbar("Request Failed..");
        console.log(err);
    } finally {
        setLoading(false);
    }
}

export const agendaTabOptions = [
    { label: "Experts View", value: "experts" },
    { label: "Questions View", value: "questions" },
  ];

export  const formatAgendaForDisplay = (agenda: AgendaEntry): FormattedAgenda => {
      const formattedResponses: AgendaQuestionResponse[] = agenda.agenda.questions.map((question) => {
        const responses = agenda.responses
          .map((expert) => {
            const matchingResponse = expert.expert_responses.find(
              (res) => res.question === question
            );
            if (!matchingResponse) return null;
  
            return {
              expert_name: expert.expert_name,
              answer: matchingResponse.answer,
              expert_note: matchingResponse.expert_note || "",
            };
          })
          .filter((res): res is NonNullable<typeof res> => res !== null); // remove nulls
  
        return {
          ques: question,
          responses,
        };
      });
  
      return {
        ...agenda,
        responses: formattedResponses,
      };
    };